// extracted by mini-css-extract-plugin
export default {"pre":"ComplaintFormBatteryProductData-Soz+h__pre"};